import { jLocale } from '@/lib/jurisdiction'
/** "Sunday 11 October" — how people at the clinic say a near date (CLA-1574). */
export function pauseDateLabel(iso: string): string {
  return new Date(iso).toLocaleDateString(jLocale(), {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  })
}
